import type { BaseModelAttributes } from "./base";
import { DataOwnershipMode, ProjectCollaborationMode } from "./permission";
import { Locale } from "./locale";
import { I18nLabels } from "./common";

export enum ProjectStatus {
  ACTIVE = "active",
  ARCHIVED = "archived",
}

export const ProjectStatusLabels: I18nLabels<ProjectStatus> = {
  [ProjectStatus.ACTIVE]: { [Locale.ZH_CN]: "进行中", [Locale.EN_US]: "Active" },
  [ProjectStatus.ARCHIVED]: { [Locale.ZH_CN]: "已归档", [Locale.EN_US]: "Archived" },
};

export interface IProject extends BaseModelAttributes {
  name: string;
  description: string | null;
  status: ProjectStatus;
  ownerId: string;
  dataOwnershipMode: DataOwnershipMode;
  defaultCollaborationMode: ProjectCollaborationMode;
}

export interface ProjectResponse {
  id: string;
  name: string;
  description: string | null;
  status: ProjectStatus;
  ownerId: string;
  ownerName?: string | null;
  dataOwnershipMode: DataOwnershipMode;
  defaultCollaborationMode: ProjectCollaborationMode;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  createdBy: string | null;
  updatedBy: string | null;
}

export interface CreateProjectRequest {
  name: string;
  description?: string;
  status?: ProjectStatus;
  ownerId?: string;
  dataOwnershipMode?: DataOwnershipMode;
  defaultCollaborationMode?: ProjectCollaborationMode;
}

export interface UpdateProjectRequest {
  name?: string;
  description?: string;
  status?: ProjectStatus;
  ownerId?: string;
  dataOwnershipMode?: DataOwnershipMode;
  defaultCollaborationMode?: ProjectCollaborationMode;
}

export interface ProjectStatistics {
  totalProjects: number;
  activeProjects: number;
  archivedProjects: number;
  deletedProjects: number;
  timestamp: Date;
}
